import { postingsLabel } from '../../../../utils/fundStatementLabels';
import type { StatementLine } from '../../../../utils/statementBlocks';
import { LABEL_SPAN_TO_NET, STATEMENT_GRID } from './statementGrid';
import { StatementLineFigures } from './StatementLineFigures';
import { StatementLineSubRows } from './StatementLineSubRows';
import { UnsplitBadge } from './UnsplitBadge';

interface Props {
    line: StatementLine;
    split: boolean;
    currency: string;
}

export function StatementLineRow({ line, split, currency }: Props) {
    return (
        <>
            <div className={`${STATEMENT_GRID} text-sm`}>
                <dt className={`flex flex-wrap items-center gap-2 ${split ? '' : LABEL_SPAN_TO_NET}`}>
                    <span>
                        {line.label}
                        <span className="text-mp-muted">{postingsLabel('', line.postings)}</span>
                    </span>
                    {line.unsplit.postings > 0 && <UnsplitBadge postings={line.unsplit.postings} />}
                </dt>
                <StatementLineFigures line={line} split={split} currency={currency} />
            </div>
            {split && <StatementLineSubRows line={line} currency={currency} />}
        </>
    );
}
